import styled from "styled-components";
import Color from "../../assets/color";

const HeaderStyled = styled.div`
  header {
    height: 70px;

    @media (max-width: 991px) {
      height: 59px;
    }
    @media (max-width: 575px) {
      height: 50px;
    }
    .navbar {
      z-index: 99;
      .navbar-brand {
        padding-top: 0;
        padding-bottom: 0;

        .logo {
          display: inline-block;
          img {
            width: 190px;

            @media (max-width: 991px) {
              width: 150px;
            }
            @media (max-width: 575px) {
              width: 130px;
            }
          }
        }
      }

      .navbar-toggler {
        padding: 0;
        border: 0;

        :focus {
          outline: none;
        }
        .mobile-profile-img {
          width: 35px;
          height: 35px;
          border: 2px solid ${Color.black};
          border-radius: 50%;
        }
      }

      .navbar-nav {
        @media (max-width: 991px) {
          margin-top: 0.5rem;
        }

        .nav-item {
          display: flex;
          align-items: center;

          @media (max-width: 991px) {
            :not(:last-child) {
              border-bottom: 1px solid ${Color.athens};
            }
          }

          &.profile-details {
            border-bottom: 0;
            margin-bottom: 8px;
            .profile-img {
              width: 35px;
              height: 35px;
              object-fit: cover;
              border-radius: 100%;
              border: 2px solid ${Color.black};
            }
            .profile-name {
              margin-left: 0.5rem;
              font-family: "Lato Italic", sans-serif;
              color: ${Color.emperor};
            }
          }

          .nav-link {
            position: relative;
            font-size: 14px;
            color: ${Color.black};
            cursor: pointer;

            @media (min-width: 992px) {
              padding-right: 0.8rem;
              padding-left: 0.8rem;
            }

            .icon-container {
              @media (max-width: 991px) {
                width: 20px;
                margin-right: 18px;
              }
              svg {
                fill: ${Color.black};
              }
            }

            &.active,
            :active {
              color: ${Color.primary};
              .icon-container {
                svg {
                  fill: ${Color.primary};
                }
              }
            }

            :hover {
              color: ${Color.pizazz};

              .icon-container {
                svg {
                  fill: ${Color.pizazz};
                }
              }
            }

            .badge.unread-notification {
              position: absolute;
              top: 8px;
              left: 50%;
              background: ${Color.primary};
              color: ${Color.white};
              font-size: 8px;
              padding: 2px 4px;
              border-radius: 20px;
              @media (max-width: 991px) {
                left: 10px;
              }
            }
            .profile-img {
              width: 40px;
              height: 40px;
              object-fit: cover;
              border-radius: 100%;
              border: 2px solid ${Color.black};
            }
          }

          &.dropdown {
            .dropdown-toggle {
              @media (min-width: 992px) {
                padding-right: 0;
              }
              :after {
                position: absolute;
                right: 0;
                top: 15px;

                @media (min-width: 992px) {
                  display: none;
                }
              }
            }
            &.show {
              display: block;

              @media (max-width: 991px) {
                .nav-link {
                  padding-bottom: 0;
                }
              }
            }

            .nav-link {
              display: block;
              width: 100%;
            }

            .dropdown-menu {
              border: 0;
              border-radius: 0;
              box-shadow: 0 0 7px 2px rgba(0, 0, 0, 0.1);
              padding: 0.5rem 1.5rem;

              .dropdown-item {
                font-size: 14px;
                cursor: pointer;

                @media (min-width: 992px) {
                  text-align: center;
                }

                &.active {
                  color: ${Color.primary};
                  background: none;
                }
                :hover {
                  color: ${Color.pizazz};
                  background: none;
                }
                .nav-link {
                  padding: 0;
                }
                .wallet-balance {
                  font-size: 12px;
                  color: ${Color.primary};
                  display: block;
                  margin-top: 0.2rem;
                }
              }
              .dropdown-divider {
                border-top: 1px solid ${Color.athensGrey};
              }

              @media (max-width: 991px) {
                background: none;
                box-shadow: none;
                padding: 0;
                padding-left: 2.4rem;

                .dropdown-item {
                  padding: 0.25rem 0.5rem;
                  padding-left: 0;
                }
                .dropdown-divider {
                  margin: 0.3rem 0;
                  border-top: 1px solid ${Color.athens};
                }
              }
            }
          }
        }
      }
    }
  }

  .download-app-container {
    display: flex;
    justify-content: space-between;
    padding: 8px 15px;
    align-items: center;

    .app-info {
      display: flex;
      padding-right: 10px;

      .close-icon {
        display: flex;
        padding-right: 5px;
      }

      .app-icon {
        width: 40px;
        height: 40px;
        margin-right: 8px;
        border-radius: 5px;
      }

      .app-name {
        margin-bottom: 0;
      }
    }
  }
`;

export default HeaderStyled;
